import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import "@/App.css";
import { PageHeader, CommissionsBlock } from "@/sections";

export default function CommissionsPage() {
  const [content, setContent] = useState(null);
  useEffect(() => {
    api.get("/site-content").then((r) => setContent(r.data)).catch(() => {});
  }, []);
  return (
    <div className="App">
      <Nav artisanName={content?.artisan_name || "Sacred Instruments"} />
      <PageHeader
        eyebrow="Custom Commissions"
        title="Ask for a piece made just for you."
        subtitle="Tell me about the sound, size, or intention you're looking for. Every commission begins with a conversation, and each piece takes its own time to be born."
      />
      <CommissionsBlock />
      <Footer content={content || {}} />
    </div>
  );
}
